export const ADD_LOCATION = 'ADD_LOCATION'
export const DELETE_LOCATION = 'DELETE_LOCATION'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_STATES = 'SET_STATES'
export const RESET_LOCATION = 'RESET_LOCATION'

export const SET_KPI_STATS = 'SET_KPI_STATS'



// WEBPACK FOOTER //
// ./src/store/modules/location/types.js